import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tableCornerRadius bg-white" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "relative flex regular pl-4" }
const _hoisted_13 = ["onMousemove"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "table-ellipsis" }
const _hoisted_17 = ["onMousemove"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.entityId === 20010 || _ctx.entityId === 20011)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["table-container", _ctx.entityId === 20011 ? 'displayDashboardTable' : 'displayHeatMapTable'])
        }, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  key: columnName,
                  class: _normalizeClass([_ctx.getWidth(columnName), "bg-white capitalize"]),
                  onClick: ($event: any) => (_ctx.sort(columnName))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex", _ctx.getFilterWidth(columnName)])
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(columnName)), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["sort cursor-pointer", _ctx.className == columnName ? _ctx.classSort : 'opacity-50'])
                    }, null, 2)
                  ], 2)
                ], 10, _hoisted_2))
              }), 128))
            ]),
            (_ctx.loadData1 == true || _ctx.loadData2 == true|| _ctx.loadData3 == true)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                  _createElementVNode("tr", _hoisted_4, [
                    _createElementVNode("td", {
                      class: "relative h-5",
                      colspan: _ctx.columnNames.size
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_dots_loader)
                      ])
                    ], 8, _hoisted_5)
                  ])
                ]))
              : (_ctx.sortedData.length == 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                    _createElementVNode("tr", _hoisted_8, [
                      _createElementVNode("td", {
                        class: "relative h-10",
                        colspan: _ctx.columnNames.size
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("div", { class: "flex justify-center" }, [
                          _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                        ], -1)
                      ]), 8, _hoisted_9)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass([((index + 1) % _ctx.pageSize === 0) ? 'noBorderForLastTr' : 'BorderForTr', "cursor-pointer rowHeight"]),
                        key: row.Country
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (columnName) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: columnName,
                            onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse())),
                            class: "cursor-pointer relative"
                          }, [
                            (columnName == 'severity')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["flex items-center justify-center rounded-full ml-2 w-5 h-5", _ctx.colorPropBg('border', row.severity)]),
                                      onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'circleButton'))
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', row.severity)])
                                      }, null, 2)
                                    ], 42, _hoisted_13)
                                  ])
                                ]))
                              : (columnName == 'selectedTier' || columnName == 'tier')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.getTierName(row[columnName])), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", {
                                        onMousemove: ($event: any) => (_ctx.toolTip(columnName, $event, index, row, 'text'))
                                      }, _toDisplayString(row[columnName]), 41, _hoisted_17)
                                    ])
                                  ]))
                          ], 32))
                        }), 128))
                      ], 2))
                    }), 128))
                  ]))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_pagination, {
      dynamicPagination: _ctx.dynamicPagination,
      onCurrentPageUpdate: _ctx.paginationUpdations,
      entityId: _ctx.entityId,
      sortedData: _ctx.sortedData
    }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "entityId", "sortedData"])
  ]))
}